import React, {useEffect, useState} from 'react';

import classes from './MobileScheduleGrid.module.scss';

import {
    getNextLessonToEnd,
    getWeekFilterSelectionInfo,
    ifGrayOutScheduleItem,
    lessonIsAnnouncement,
    sortScheduleLessons
} from '../../../services/scheduleService';

import ScheduleGridItem from '../ScheduleGrid/ScheduleGridItem/ScheduleGridItem';
import AnnouncementGridItem from '../Announcement/AnnouncementGridItem/AnnouncementGridItem';
import {stringToDateTime} from "../../../services/generalService";
import {useSelector} from "react-redux";
import useDefaultWeek from "../ScheduleFilters/useDefaultWeek";
import {getDateLabel, getDateOfWeekdayOptions} from "../CommonSchedule/common";

const MobileScheduleGrid = ({ scheduleData, scheduleItemType, scheduleType, isCurrentPeriod,
                                startOfTermDate }) => {
    const STUDY_DAYS_AMOUNT = 6
    const [days] = useState(['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота']);
    const [rerenderTimeoutId, setRerenderTimeoutId] = useState(null)

    const currentWeek = useSelector(state => state.schedule.currentWeekNumber);
    const defaultWeek = useDefaultWeek(startOfTermDate);

    const weekFilters = useSelector(state => state.schedule.weekFilters);

    const weekFilterSelection = getWeekFilterSelectionInfo(weekFilters, currentWeek, defaultWeek);
    const dateOfWeekdayOptions = getDateOfWeekdayOptions(weekFilterSelection, startOfTermDate, isCurrentPeriod);
    const dateOfWeekdayOption = dateOfWeekdayOptions.find(o => o.shouldApply);

    const schedule = sortScheduleLessons(Object.entries(scheduleData ?? {}));

    // TODO: это что
    useEffect(() => { // Написано с расчётом на таймер для ежедневного обновления
        let timeoutId = null;

        const currentDate = new Date();

        let dayIndex = currentDate.getDay();
        if (dayIndex) dayIndex--;

        const specifiedDaySchedule = schedule.find(daySchedule => daySchedule[0] === days[dayIndex]);
        if (specifiedDaySchedule && specifiedDaySchedule[1].length) {
            const dayLessons = specifiedDaySchedule[1];
            const currentTime = currentDate.getTime();

            const nextLessonToEnd = getNextLessonToEnd(dayLessons, currentTime);
            if (nextLessonToEnd) {
                const nextEndLessonTime = stringToDateTime(nextLessonToEnd.endLessonTime).getTime();
                const nextRerenderTime = nextEndLessonTime + 60*1000;//1 минута
                timeoutId = setTimeout(() => {
                    setRerenderTimeoutId(timeoutId);
                }, nextRerenderTime - currentTime);
            }
        }

        return () => clearTimeout(timeoutId);
    }, [rerenderTimeoutId, schedule, days])

    useEffect(() => {
        if (scheduleData) {
            setTimeout(() => scrollToCurrentDay(), 5);
        }
    }, []);

    const scrollToCurrentDay = () => {
        const day = new Date().getDay();
        let elemToScrollTo;

        if (day >= 1 && day <= STUDY_DAYS_AMOUNT) {
            elemToScrollTo = document.getElementById(days[day - 1]);
        } else {
            elemToScrollTo = document.getElementById('Понедельник');
        }

        if (elemToScrollTo) {
            const yOffset = -80;
            const y = elemToScrollTo.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
        }
    }

    const setDateLabel = (dayName, dayIndex) => {
        const currentDay = dateOfWeekdayOption?.getDate(dayIndex + 1);
        if (!currentDay) return null;

        return <div>{getDateLabel(currentDay)}</div>
    }

    const setScheduleDay = () => {
        const studyDays = [];

        for (let i = 0; i < STUDY_DAYS_AMOUNT; i++) {
            studyDays.push(
                <div key={i} id={days[i]}>
                    <div className={classes.weekDayContainer}>
                        <div>{days[i]}</div>
                        <div>{setDateLabel(days[i], i)}</div>
                    </div>
                    <div className={classes.lessonsContainer}>
                        {setLessonsPerDay(i)}
                    </div>
                </div>
            )
        }
        return studyDays;
    }

    const setLessonsPerDay = (dayIndex) => {
        let lessons = [];
        const specifiedDaySchedule = schedule.find(daySchedule => daySchedule[0] === days[dayIndex]);
        if (specifiedDaySchedule && specifiedDaySchedule[1].length
            && (!dateOfWeekdayOption || dateOfWeekdayOption.shouldDisplayDayLessons(dayIndex + 1))) {
            const dayLessons = specifiedDaySchedule[1];
            const currentTime = (new Date()).getTime();
            const nextLessonToEnd = getNextLessonToEnd(dayLessons, currentTime);

            for (let dayLessonIndex = 0; dayLessonIndex < dayLessons.length; dayLessonIndex++) {
                const lesson = dayLessons[dayLessonIndex];
                const lessonPeriodIsCurrent = lesson.endLessonTime === nextLessonToEnd?.endLessonTime;

                if (!lessonIsAnnouncement(lesson)) lessons.push(setLessonItem(lesson, dayIndex, dayLessonIndex, lessonPeriodIsCurrent));
                else lessons.push(setAnnouncementItem(lesson, dayIndex, dayLessonIndex));
            }
        } else {
            lessons.push(<div key={days[dayIndex]} className={classes.emptyDay}>Занятий нет</div>);
        }
        return lessons;
    }

    const setLessonItem = (lesson, dayIndex, lessonIndex, lessonPeriodIsCurrent) => {
        return <ScheduleGridItem
            key={dayIndex + lessonIndex * (STUDY_DAYS_AMOUNT + 1)}
            ifMobileGrid
            lesson={lesson}
            scheduleItemType={lesson.dateLesson ? "examLesson" : scheduleItemType}
            scheduleType={scheduleType}
            dayName={days[dayIndex]}
            lessonPeriodIsCurrent={lessonPeriodIsCurrent}
            shouldGrayOut={ifGrayOutScheduleItem(lesson, weekFilterSelection.onlyDefaultWeekSelected, isCurrentPeriod)}/>
    }

    const setAnnouncementItem = (lesson, dayIndex, lessonIndex) => {
        return <AnnouncementGridItem
            key={`announcement${dayIndex + lessonIndex * (STUDY_DAYS_AMOUNT + 1)}`}
            ifMobileGrid
            scheduleType={scheduleType}
            note={lesson.note}
            date={lesson.startLessonDate}
            startLessonTime={lesson.startLessonTime}
            endLessonTime={lesson.endLessonTime}
            employees={lesson.employees}
            studentGroups={lesson.studentGroups}
            auditory={lesson.auditories}
            shouldGrayOut={ifGrayOutScheduleItem(lesson, weekFilterSelection.onlyDefaultWeekSelected, isCurrentPeriod)}/>
    }

    return (
        <div className={classes.scheduleContainer}>
            {setScheduleDay()}
        </div>
    )
};

export default MobileScheduleGrid;
